document.addEventListener('DOMContentLoaded', function () {
  let loading = false;
  let nextPageUrl = null;

  function getNextPageUrl() {
    const pagination = document.querySelector('.pagination-wrapper');

    if (!pagination) return null;

    const nextLink =
      pagination.querySelector('a[aria-label*="Next"]') ||
      pagination.querySelector('a[aria-label*="next"]');

    return nextLink ? nextLink.href : null;
  }

  function updateNextPageUrl() {
    nextPageUrl = getNextPageUrl();
  }

  async function loadMoreProducts() {
    if (loading || !nextPageUrl) return;

    const productGrid = document.querySelector('#product-grid');
    const loader = document.querySelector('#infinite-scroll-loader');

    if (!productGrid) return;

    loading = true;

    if (loader) {
      loader.style.display = 'block';
    }

    try {
      const response = await fetch(nextPageUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('Could not load the next page.');
      }

      const html = await response.text();

      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, 'text/html');

      const newProducts = newDocument.querySelectorAll(
        '#product-grid > li'
      );

      newProducts.forEach(function (product) {
        productGrid.appendChild(product);
      });

      const newPagination = newDocument.querySelector(
        '.pagination-wrapper'
      );

      if (newPagination) {
        const newNextLink =
          newPagination.querySelector('a[aria-label*="Next"]') ||
          newPagination.querySelector('a[aria-label*="next"]');

        nextPageUrl = newNextLink ? newNextLink.href : null;
      } else {
        nextPageUrl = null;
      }

    } catch (error) {
      console.error('Infinite scroll error:', error);
    }

    loading = false;

    if (loader) {
      loader.style.display = 'none';
    }
  }

  updateNextPageUrl();

  window.addEventListener('scroll', function () {
    if (loading || !nextPageUrl) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;

    if (scrollPosition >= pageHeight - 1200) {
      loadMoreProducts();
    }
  });

  /*
   * Re-check pagination when Shopify updates the collection
   * after a filter or sorting change.
   */
  const productGridContainer = document.querySelector(
    '#ProductGridContainer'
  );

  if (productGridContainer) {
    const observer = new MutationObserver(function () {
      if (!loading) {
        updateNextPageUrl();
      }
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }
});